// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3a9fe849","833":"d9552154"}[chunkId] + ".chunk.js";
};